import React from 'react';
import ActiveVagas from '../components/ActiveVagas';

export default function VagasPage() {
  return (
    <div>
      <h5 className='reconect-text'>VAGAS</h5>
      <ActiveVagas />
    </div>
  );
}
